import 'regenerator-runtime/runtime'

import React from 'react'
import ReactDOM from 'react-dom'

import { GlobalStyles } from 'config'

import { OptimizelyProvider } from '@optimizely/react-sdk'
import { initializeDatadog } from 'config/analytics'
import createEnvironment from 'config/env'
import initializeSentryClient from 'config/sentry'
import queryString from 'query-string'

import {
  ACORNS_HELLO_FLOW,
  APP_ID,
  AUTH_TOKEN,
  USER_EMAIL,
  USER_UUID,
  VISITED_PAGES,
} from 'app-constants'
import platform, { deviceType } from 'components/Trackers/platform'
import theme from 'theme'
import { closeSession } from 'utils/auth'
import createBackendClient from 'utils/backend'
import { sendToSentry } from 'utils/errors'
import { initializeOptimizelyOverride } from 'utils/Optimizely/featureToggle'
import InitializeOptimizely from 'utils/Optimizely/Optimizely'
import { setVisitorId } from 'utils/setVisitorId'

import Application from './application'

const visitorId = setVisitorId()

const environment = createEnvironment()
if (document.referrer?.includes(environment.get('loginUrl'))) {
  /**
   * If the user hits Sign Up button on login app
   * they would want to create a new account.
   * We need to close the session to allow that.
   */

  const queryParams = queryString.parse(window.location.search)

  if (queryParams?.newUser === 'true') {
    const keys = [ACORNS_HELLO_FLOW, AUTH_TOKEN, USER_EMAIL, VISITED_PAGES, USER_UUID]
    keys.forEach(key => {
      window.localStorage.removeItem(key)
      window.sessionStorage.removeItem(key)
    })

    closeSession()
  }
}

initializeSentryClient(environment)
initializeDatadog(environment.get('datadogKey'))
const backendClient = createBackendClient(environment.get('backend'))

let optimizely
try {
  optimizely = new InitializeOptimizely(
    environment.get('optimizelyClient'),
    environment.get('frontendEventProxyHost'),
  ).initialize()

  if (environment.get('buildEnv') !== 'production') {
    initializeOptimizelyOverride(optimizely)
  }
} catch (e) {
  sendToSentry(e, {
    name: 'OptimizelyError',
    message: 'Failed to update user flow in Backend via mutation.',
  })
}
// initializePageAnalytics(optimizely, environment, visitorId)

ReactDOM.render(
  <>
    <GlobalStyles />
    {optimizely ? (
      <OptimizelyProvider
        optimizely={optimizely}
        user={{
          id: visitorId,
          attributes: {
            deviceType,
            environment: environment.get('optimizelyEnvironment'),
            platform,
            visitorId,
          },
        }}
      >
        <Application
          optimizely={optimizely}
          appId={APP_ID}
          backend={backendClient}
          environment={environment}
          theme={theme}
        />
      </OptimizelyProvider>
    ) : (
      <Application appId={APP_ID} backend={backendClient} environment={environment} theme={theme} />
    )}
  </>,
  document.getElementById('app'),
)
